import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";
import NewsCard from "../../components/Cards/ArticlesCard";
import { useArticles } from "../../contexts/ArticlesContext";

function ArticlesPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { articles, loading } = useArticles();

  const categories = [
    "All",
    "Research",
    "Innovation",
    "Field Work",
    "Publications",
  ];

  // Filter articles based on search query and category
  const filteredArticles = articles.filter((article) => {
    const matchesSearch =
      article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      `${article.authorName} ${article.authorPosition} ${article.authorAffiliation}`
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

    const matchesCategory =
      selectedCategory === "All" || article.category === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  return (
    <div className="p-6 min-h-screen bg-gray-50">
      {/* Introductory Text Section */}
      <div className="mb-12 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
          Geological Engineering Articles Hub
        </h2>
      </div>

      {/* Search and Filter Section */}
      <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-8">
        <div className="relative w-full md:w-1/3 mb-4 md:mb-0">
          <div className="relative flex items-center   ml-10">
            <input
              type="text"
              placeholder="Search articles..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full p-3 pl-12 rounded-lg border ml-10 border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
        </div>
        <div className="relative w-full md:w-auto md:ml-4">
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="w-full md:w-auto px-4 py-3 md:py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 md:h-auto h-12"
          >
            Filter
          </button>
          {dropdownOpen && (
            <div className="absolute left-0 mt-2 w-full md:w-48 bg-white border border-gray-300 shadow-lg rounded-lg z-10 overflow-hidden">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => {
                    setSelectedCategory(category);
                    setDropdownOpen(false);
                  }}
                  className={`block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-200 ${
                    selectedCategory === category ? "bg-gray-300" : ""
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Articles Grid Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {loading ? (
          <p className="col-span-full text-center text-gray-600">
            Loading articles...
          </p>
        ) : filteredArticles.length > 0 ? (
          filteredArticles.map((article) => (
            <NewsCard
              key={article.id}
              id={article.id}
              image={article.image}
              title={article.title}
              time={article.time}
              authorAffiliation={article.authorAffiliation}
              authorName={article.authorName}
              authorPosition={article.authorPosition}
              references={article.references}
              conclusion={article.conclusion}
              category={article.category}
            />
          ))
        ) : (
          <p className="col-span-full text-center text-gray-600">
            No articles found matching your criteria.
          </p>
        )}
      </div>
    </div>
  );
}

export default ArticlesPage;
